
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'MediaPage',
}) 
export default class MediaPage extends Vue {
}
